<template>
  <a-link
    v-if="!inProgress && isVisible"
    :to="to"
    tabindex="0"
    class="a-view-more__wrapper"
    :class="dynamicClass"
    @click="$emit('click')"
    @keydown.enter="onEnter"
    @focus="onFocus"
  >
    <a-icon
      :icon="$options.consts.ICON.PLUS_CIRCLE_ICON"
      :width="16"
      :height="16"
      original
      class="a-view-more__icon"
    />
    <span class="a-view-more__text text-medium">View more</span>
  </a-link>
  <a-spinner v-else-if="inProgress" disable-transition />
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon'
import { PROP_TYPES, propValidator } from '@/utils/validators'
import ASpinner from 'shared/ASpinner'
import {
  VIEW_MORE_STYLE,
  CLASS_BY_VIEW_MORE_STYLE
} from 'shared/AViewMore/enums'

const VIEW_MORE_STYLE_VALUES = Object.values(VIEW_MORE_STYLE)

export default {
  name: 'AViewMore',
  components: { AIcon, ASpinner },
  props: {
    to: propValidator([PROP_TYPES.STRING, PROP_TYPES.OBJECT], false, ''),
    inProgress: propValidator([PROP_TYPES.BOOLEAN], false, false),
    page: propValidator([PROP_TYPES.NUMBER], false),
    pagesCount: propValidator([PROP_TYPES.NUMBER], false),
    viewMoreStyle: propValidator(
      [PROP_TYPES.STRING],
      false,
      VIEW_MORE_STYLE.LINK,
      value => VIEW_MORE_STYLE_VALUES.includes(value)
    )
  },
  data() {
    return {
      previousFocusElement: null
    }
  },
  consts: { ICON },
  computed: {
    isPaginated() {
      return this.page != null && this.pagesCount != null
    },
    isVisible() {
      if (!this.isPaginated) return true

      if (!this.pagesCount) return false

      return this.page !== this.pagesCount - 1
    },
    dynamicClass() {
      return {
        [CLASS_BY_VIEW_MORE_STYLE[this.viewMoreStyle]]: true
      }
    }
  },
  methods: {
    onEnter(event) {
      event.preventDefault()
      this.$emit('click', event)

      if (this.previousFocusElement) {
        this.previousFocusElement.focus()
        this.previousFocusElement = null
      }
    },
    onFocus(event) {
      this.previousFocusElement = event.relatedTarget
    }
  }
}
</script>

<style lang="scss" scoped>
.a-view-more__wrapper {
  display: flex;
  color: $c--black;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: $c--main;
    text-decoration: underline;
  }
}

.a-view-more__link {
  justify-content: flex-end;
}

.a-view-more__button {
  height: 40px;
  padding: 8px 24px;
  justify-content: center;
  align-self: stretch;
  border-radius: 4px;
  background: $c--gray-soft;
}

.a-view-more__text {
  margin-left: 5px;
  font-weight: 700;
}
</style>
